"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.validation.stepsRequired': 'At least one step is required',
    'tutorial.validation.stepTitleRequired': 'Step {index} title is required',
    'tutorial.validation.stepSectionsRequired': 'Step {index} must have at least one section',
    'tutorial.validation.nameRequired': 'Tutorial name is required',
    'tutorial.validation.sectionsRequired': 'At least one section is required',
    'tutorial.validation.sectionTitleRequired': 'Section {index} title is required',
};
